/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_Desc_MediumInputs */



/**
* | output |
* | --- |
* | "Balanced reasoning depth. Recommended default." |
*
* @param {Model_Settings_Reasoning_Desc_MediumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_desc_medium = /** @type {((inputs?: Model_Settings_Reasoning_Desc_MediumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_Desc_MediumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewogene Begründungstiefe. Empfohlen als Standard.")
	return /** @type {LocalizedString} */ ("Balanced reasoning depth. Recommended default.")
});